import { useMediaQuery } from '@mui/material'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { useState } from 'react'
import NoResult from '../../shared/UI/NoResult'
import theme from '../../theme/theme'
import { PaginationInfo } from '../Search'
import { SicknessSummarySearchItem } from '../../types/sickness-summary-search'
import { ReportingSummarySicknessFilters } from '../SicknessSummary'

export type MySicknessSummarySearchGridPropsLocal = {
  rows: SicknessSummarySearchItem[]
  filtersState?: ReportingSummarySicknessFilters | null
  pagination?: PaginationInfo | null
}

function NoRowsOverlay() {
  return <NoResult message="No Results" showImage />
}

const DEFAULT_PAGE_SIZE = 10

function SicknessSummarySearchGrid(props: MySicknessSummarySearchGridPropsLocal) {
  const [pageSize, setPageSize] = useState<number>(props.pagination?.pageSize ?? DEFAULT_PAGE_SIZE)
  const [pageNumber, setPageNumber] = useState<number>(props.pagination?.pageNumber ?? 0)
  const mobile = useMediaQuery(theme.breakpoints.down('sm'))

  const columns: GridColDef[] = [
    {
      field: 'displayName',
      headerName: 'Name',
      headerClassName: 'header',
      flex: 1,
    },
    {
      field: 'departmentName',
      headerName: 'Department',
      headerClassName: 'header',
      flex: 1,
    },
    {
      field: 'teamName',
      headerName: 'Team',
      headerClassName: 'header',
      flex: 1,
    },
    {
      field: 'occurrences',
      headerName: 'Number of Absences',
      headerClassName: 'header',
      flex: 1,
    },
    {
      field: 'hours',
      headerName: 'Hours',
      headerClassName: 'header',
      flex: 1,
    },
  ]

  const mobileColumns: GridColDef[] = [
    {
      field: 'displayName',
      headerName: 'Name',
      headerClassName: 'header',
      flex: 1,
    },
    {
      field: 'occurrences',
      headerName: 'Occurrences',
      headerClassName: 'header',
      flex: 1,
    },
    {
      field: 'hours',
      headerName: 'Hours',
      headerClassName: 'header',
      flex: 1,
    },
  ]
  return (
    <DataGrid
      rows={props.rows}
      columns={mobile ? mobileColumns : columns}
      getRowId={row => row.employeeId}
      disableSelectionOnClick
      rowsPerPageOptions={[10, 25, 50, 100]}
      rowHeight={50}
      autoHeight
      components={{ NoRowsOverlay }}
      pageSize={pageSize}
      page={pageNumber}
      onPageSizeChange={newPageSize => setPageSize(newPageSize)}
      onPageChange={newPageNumber => setPageNumber(newPageNumber)}
      initialState={{
        sorting: {
          sortModel: [{ field: 'displayName', sort: 'asc' }],
        },
      }}
      sx={{
        '&.MuiDataGrid-root': {
          border: 'none',
        },
        '.header': {
          backgroundColor: 'rgb(247, 247, 247)',
        },
        '& .MuiDataGrid-virtualScrollerContent': {
          minHeight: '200px!important',
        },
        '.headerEmpty': {
          backgroundColor: 'rgb(247, 247, 247)',
        },
        '.headerEmpty .MuiDataGrid-columnHeaderTitle': {
          color: 'rgb(247, 247, 247)',
        },
      }}
      componentsProps={{
        panel: {
          sx: {
            '& .MuiNativeSelect-select option': {
              font: '13px "Poppins", sans-serif',
            },
          },
        },
      }}
    />
  )
}

export default SicknessSummarySearchGrid
